// extracted by mini-css-extract-plugin
export default {"wrapper":"Home-module__wrapper___d_jMs","loginWrapper":"Home-module__loginWrapper___Ak0OB"};